import { T_Timeframe } from '@/ts/types/T_Chart';

export const C_DEFAULT_POOL_TIMEFRAME: T_Timeframe = '12H';
export const C_DEFAULT_PREDICTION_TIMEFRAME: T_Timeframe = '1H';
